export default __webpack_public_path__ + "media/images/symbols/arrow-left-82cc401f66ffad1ac01d663018499fc8.svg";